import React, { useEffect, useState } from "react";
import ModalDropdown from "../ModalComponents/ModalDropdown";
import "../Modals.css";
import ModalCreationMessage from "../ModalCreationMessage";
import MissionModelingService from "../../MissionModelingService";
import { toast } from "react-toastify";
import BoundingBox from "../BoundingBox/BoundingBox";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";

const GroundStationModal = ({ props, parameterProps }) => {
  const params = useParams()
  const {
    mission_name,
    mission_id
  } = params;

  const [isModalVisible, setisModalVisible] = useState(true);
  const [isSelectedModalComponent, setSelectedModalComponent] =
    useState("List");
  const [isSuccessMsgVisible, setIsSuccessMsgVisible] = useState(false);
  const [message, setMessage] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [height, setHeight] = useState("");
  const [minBandwidth, setMinBandwidth] = useState("");
  const [frequencyType, setFrequencyType] = useState([]);
  const [isBoundingBox, setBoundingBox] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedGsIds, setSelectedGsIds] = useState([]);
  const [previousOption, setPreviousOption] = useState("")
  const [isEdit, setIsEdit] = useState(false)
  const [loading, setLoading] = useState(false)


  const [frequencyBandItems, setFrequencyBandItems] = useState({
    XBand: true,
    SBand: true,
    UHF: true,
  });
  const boundingBoxCoordinateList: string[][] = [];

  props.boundingBoxCoordinates?.map((item) => {
    boundingBoxCoordinateList.push(item);
  });
  const setboundingBoxParameters = (boundingBoxCoordinates) => {
    props.setModalProps({ boundingBoxCoordinates: boundingBoxCoordinates });
  };
  //getAllGs
  useEffect(() => {
    MissionModelingService.getAllGlobalGroundStation(mission_id)
      .then((res) => {
        const transformedOptions = res.data.map((item) => ({
          label: item.groundstationName,
          value: item.groundstationId,
        }));
        setDropdownOptions(transformedOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const showSuccessMessage = (msg) => {
    setMessage(msg);
    setIsSuccessMsgVisible(true);
    setTimeout(() => {
      setIsSuccessMsgVisible(false);
      props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
    }, 2000);
  };

  const postGroundStation = () => {

    setLoading(true)

    let currentNumber;

    if (props?.groundStationLatestName) {
      currentNumber = parseInt(props.groundStationLatestName.split('_')[1], 10);

      if (isNaN(currentNumber)) {
        currentNumber = 1;
      }
    } else {
      currentNumber = 0;
    }

    const nextNumber = currentNumber + 1;
    const latestGSName = `gs-manual_${nextNumber.toString().padStart(2, '0')}`;





    let gsList = [];
    let userObject = {};

    let requestType = isSelectedModalComponent === "List" ? "global" : "user"

    if (requestType === 'user') {
      userObject = {
        "latitude": parseFloat(latitude),
        "longitude": parseFloat(longitude),
        "height": parseFloat(height),
        "minimum_bandwidth": parseFloat(minBandwidth),
        "frequencyBand": {
          "SBand": frequencyBandItems.SBand,
          "XBand": frequencyBandItems.XBand,
          "UHF": frequencyBandItems.UHF
        },
        "elevation": 0,
        "groundstationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        "groundstationName": latestGSName
      }


    } else {
      selectedGsIds?.map((item) => {
        gsList.push(item?.['value'])
      })
    }

    let data = {
      "requestType": requestType,
      "globalId": gsList,
      "user": userObject
    }

    MissionModelingService.postGroundStation(data, mission_id)
      .then((res) => {
        props.setSidebarProps({
          isSidebarVisible: props.isSidebarVisible,
          sidebarComponent: props.sidebarComponent,
          isComponentUpdated: !props.isComponentUpdated,
        });

        props.setNames(prevProps => ({
          ...prevProps,
          groundStationLatestName: latestGSName,
        }));

        showSuccessMessage("Ground Station added successfully");
        props.setSidebarProps({ isSidebarVisible: true });
        setLoading(false);
        setisModalVisible(false);


        // props.setBottombarProps({ bottombarComponent: ""});
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false)
      });
  }

  const handleSelectedOption = (selectedOption) => {
    console.log("Selected Option => ", selectedOption)
    setSelectedGsIds(selectedOption)
  }


  //This UseEffect used for Edit Option
  useEffect(() => {
    console.log("Inside Ground Station Modal", props.componentData.allData)
    if (props?.["componentId"]) {
      setIsEdit(true)
      setSelectedModalComponent("Add");
      setLongitude(props?.componentData?.allData?.longitude);
      setLatitude(props?.componentData?.allData?.latitude);
      setHeight(props?.componentData?.allData?.height);
      setFrequencyBandItems({
        XBand: props?.componentData?.allData?.frequencyBand?.XBand,
        SBand: props?.componentData?.allData?.frequencyBand?.SBand,
        UHF: props?.componentData?.allData?.frequencyBand?.UHF,
      })

    } else {
      setIsEdit(false)
    }
  }, [])

  return (
    <>
      {isSuccessMsgVisible && (
        <ModalCreationMessage props={props} message={message} />
      )}
      {isModalVisible && (
        <>
          <div
            className={
              props.isSidebarVisible
                ? "mainModal sidebarOpenModal"
                : "mainModal"
            }
            id="coverageAnalysis"
          >
            <div className="modalHeader">
              <div className="modalHeaderImg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                >
                  <path
                    d="M11.1158 0.639716C11.6186 0.815399 12.1001 1.14299 12.4562 1.54913C13.1894 2.38414 13.1796 3.3137 12.9145 4.33524C12.8996 4.39239 12.8626 4.44129 12.8117 4.47118C12.7608 4.50108 12.7001 4.50952 12.6429 4.49465C12.5858 4.47978 12.5369 4.44282 12.507 4.3919C12.4771 4.34097 12.4687 4.28026 12.4835 4.22312C12.7326 3.26358 12.713 2.51642 12.1218 1.84262C11.8095 1.4892 11.4132 1.22001 10.9696 1.0598C10.5391 0.909957 10.1253 0.902723 9.80438 1.0629C9.75155 1.08922 9.69044 1.09346 9.63448 1.07471C9.57852 1.05596 9.5323 1.01575 9.50598 0.96292C9.47967 0.910091 9.47542 0.848973 9.49417 0.793012C9.51293 0.737051 9.55314 0.690831 9.60597 0.664519C10.0695 0.433548 10.6161 0.465068 11.1163 0.639716H11.1158ZM3.50463 12.4001C3.64167 12.4001 3.7731 12.3456 3.87 12.2487C3.9669 12.1518 4.02134 12.0204 4.02134 11.8834C4.02134 11.7463 3.9669 11.6149 3.87 11.518C3.7731 11.4211 3.64167 11.3667 3.50463 11.3667C3.36759 11.3667 3.23616 11.4211 3.13926 11.518C3.04235 11.6149 2.98792 11.7463 2.98792 11.8834C2.98792 12.0204 3.04235 12.1518 3.13926 12.2487C3.23616 12.3456 3.36759 12.4001 3.50463 12.4001Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M11.0433 3.23824C11.1423 3.4842 11.1428 3.75886 11.0447 4.00518C10.9465 4.2515 10.7573 4.45055 10.5162 4.56102L10.6304 8.30047L11.6484 9.08174C11.7514 9.1604 11.8211 9.27491 11.8436 9.40256C11.8662 9.53021 11.8399 9.66167 11.7701 9.77087C11.7002 9.88007 11.5919 9.95902 11.4666 9.99207C11.3412 10.0251 11.208 10.0099 11.0934 9.9493C10.3938 10.7052 9.52674 11.2333 8.54085 11.3703C7.90272 11.4596 7.24236 11.3811 6.57735 11.1233L6.16398 11.6792L8.60906 13.7383C8.84055 13.9331 9.01003 14.1858 9.10407 14.4664H9.14024C9.45544 14.4664 9.71017 14.6968 9.70501 14.9831C9.70501 15.2694 9.45027 15.4998 9.13456 15.4998H1.49083C1.17564 15.4998 0.920898 15.2694 0.920898 14.9831C0.920898 14.7144 1.14515 14.4948 1.43761 14.469V11.6581C1.4375 11.3711 1.50447 11.088 1.63318 10.8315C1.76189 10.575 1.94878 10.3521 2.17893 10.1806C2.40908 10.0091 2.67612 9.89382 2.95875 9.84388C3.24138 9.79394 3.53176 9.81075 3.80674 9.89297L4.21287 9.35766C3.76643 8.78049 3.50549 8.15734 3.42075 7.50783C3.29002 6.50541 3.58765 5.51384 4.14518 4.62251C4.05008 4.53119 3.99348 4.40696 3.98698 4.27527C3.98048 4.14358 4.02457 4.01439 4.11022 3.91415C4.19587 3.8139 4.3166 3.75019 4.44769 3.73606C4.57878 3.72193 4.71031 3.75845 4.81536 3.83814L5.74286 4.54965L9.05757 3.74978C9.02633 3.50042 9.08702 3.24822 9.2283 3.04037C9.36957 2.83253 9.58175 2.68329 9.82511 2.62058C10.0685 2.55787 10.3263 2.58599 10.5505 2.69968C10.7746 2.81337 10.9501 3.00483 11.0433 3.23824ZM6.2699 4.95372L7.97609 6.26359L9.39963 4.39826C9.34433 4.34931 9.29444 4.29457 9.25082 4.23497L6.26939 4.95424L6.2699 4.95372ZM8.38584 6.57827L10.1013 7.89433L10.0021 4.65454C9.9573 4.65094 9.91276 4.64438 9.8688 4.63491L8.38584 6.57775V6.57827ZM4.96779 5.25755C4.54047 5.9732 4.35704 6.69608 4.44591 7.374C4.54047 8.09947 4.95642 8.8518 5.88237 9.54936C6.80884 10.248 7.65986 10.45 8.39773 10.3472C9.06842 10.2542 9.70604 9.89969 10.2641 9.32201L4.96779 5.25755ZM7.86965 14.4664L3.80002 11.0396C3.68227 10.9403 3.53862 10.8768 3.38598 10.8564C3.23334 10.8361 3.07806 10.8597 2.93842 10.9247C2.79879 10.9896 2.68061 11.0931 2.59781 11.2229C2.515 11.3528 2.47102 11.5036 2.47104 11.6575V14.4664H7.86965Z"
                    fill="#F0F0F0"
                  />
                  <path
                    d="M11.4454 1.96066C10.938 1.46462 10.2239 1.34836 9.61781 1.6062C9.56347 1.62936 9.52056 1.67315 9.49852 1.72795C9.47647 1.78275 9.4771 1.84406 9.50026 1.8984C9.52342 1.95273 9.56721 1.99564 9.62201 2.01769C9.67681 2.03973 9.73812 2.03911 9.79246 2.01595C10.2342 1.82786 10.7566 1.91002 11.1344 2.27947C11.5141 2.64944 11.6371 3.20749 11.4878 3.69785C11.4793 3.72584 11.4764 3.75522 11.4793 3.78433C11.4822 3.81344 11.4908 3.84169 11.5045 3.86748C11.5183 3.89327 11.5371 3.91609 11.5597 3.93464C11.5823 3.95319 11.6084 3.9671 11.6363 3.97558C11.6643 3.98406 11.6937 3.98695 11.7228 3.98407C11.7519 3.9812 11.7802 3.97262 11.806 3.95882C11.8318 3.94503 11.8546 3.92629 11.8731 3.90367C11.8917 3.88106 11.9056 3.85502 11.9141 3.82702C12.1084 3.18785 11.9513 2.45412 11.4454 1.96066Z"
                    fill="#F0F0F0"
                  />
                </svg>
              </div>
              <span>Ground Station</span>
              <button
                className="modalCloseBtn"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <path
                    d="M1.19995 10.8L10.8 1.19995"
                    stroke="#F0F0F0"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1.19993 1.19995L10.7999 10.8"
                    stroke="#F0F0F0"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>

            {!isEdit && <div className="modalComponentBox">
              <div className="modalComponentItem">
                <div className="modalComponentBtnBox">
                  <button
                    className={
                      isSelectedModalComponent === "List"
                        ? "activeModalComponentBtn modalComponentBtn"
                        : "modalComponentBtn"
                    }
                    onClick={() => {
                      setSelectedModalComponent("List");
                    }}
                  >
                    <svg width="41" height="46" viewBox="0 0 41 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.313 18.5439L23.655 17.2026C23.9898 17.3872 24.3757 17.4575 24.754 17.4028C25.1324 17.3481 25.4826 17.1714 25.7514 16.8995C25.9888 16.6668 26.1565 16.3724 26.2358 16.0496C26.315 15.7268 26.3026 15.3882 26.2 15.072C26.0974 14.7558 25.9086 14.4745 25.6548 14.2598C25.4011 14.045 25.0925 13.9053 24.7637 13.8563C24.4349 13.8073 24.0989 13.851 23.7936 13.9825C23.4883 14.114 23.2257 14.328 23.0354 14.6006C22.8451 14.8731 22.7345 15.1934 22.7162 15.5253C22.6979 15.8572 22.7726 16.1877 22.9318 16.4795L21.5899 17.8207L13.4793 9.71011C13.3834 9.61434 13.2534 9.56055 13.1179 9.56055C12.9823 9.56055 12.8524 9.61434 12.7565 9.71011C10.6827 11.7645 9.39865 14.4837 9.12964 17.3904C8.86062 20.2971 9.62381 23.2056 11.2853 25.6058C11.2279 25.793 11.1868 25.9849 11.1626 26.1792L10.4398 32.7458C9.75476 32.8742 9.13611 33.2379 8.69066 33.7739C8.24521 34.3099 8.00093 34.9846 8 35.6816V37.4886C8 37.6242 8.05388 37.7543 8.14979 37.8502C8.2457 37.9461 8.37578 38 8.51141 38C8.64705 38 8.77712 37.9461 8.87303 37.8502C8.96894 37.7543 9.02282 37.6242 9.02282 37.4886V35.6816C9.02345 35.1607 9.23068 34.6614 9.59903 34.2931C9.96738 33.9248 10.4668 33.7176 10.9877 33.7171H17.9033C18.4241 33.7177 18.9234 33.9249 19.2917 34.2932C19.66 34.6615 19.8672 35.1608 19.8678 35.6816V36.9772H9.74186C9.60623 36.9772 9.47615 37.0311 9.38024 37.127C9.28433 37.2229 9.23045 37.3529 9.23045 37.4886C9.23045 37.6242 9.28433 37.7543 9.38024 37.8502C9.47615 37.9461 9.60623 38 9.74186 38H20.3792C20.5148 38 20.6449 37.9461 20.7408 37.8502C20.8367 37.7543 20.8906 37.6242 20.8906 37.4886V35.6816C20.8895 34.9852 20.6455 34.311 20.2005 33.7753C19.7556 33.2396 19.1376 32.876 18.4532 32.7471L17.7246 26.1806C17.6386 25.3713 17.2555 24.6227 16.6495 24.0795C16.0435 23.5363 15.2576 23.237 14.4438 23.2397C13.9344 23.2417 13.4324 23.3607 12.9764 23.5876C12.5204 23.8145 12.1226 24.1431 11.8138 24.5482C10.4981 22.4292 9.91384 19.9372 10.1505 17.4543C10.3872 14.9714 11.4317 12.6347 13.124 10.8025L21.2285 18.9049L29.3313 27.0081C28.078 28.1654 26.58 29.0254 24.9487 29.5243C23.3174 30.0231 21.5946 30.1479 19.9084 29.8894C19.8419 29.8795 19.7742 29.8828 19.709 29.8992C19.6439 29.9155 19.5826 29.9445 19.5286 29.9845C19.4747 30.0245 19.4291 30.0748 19.3946 30.1324C19.3601 30.19 19.3373 30.2539 19.3274 30.3203C19.3176 30.3867 19.3209 30.4545 19.3372 30.5196C19.3535 30.5848 19.3825 30.6461 19.4226 30.7C19.4626 30.754 19.5128 30.7995 19.5704 30.8341C19.6281 30.8686 19.6919 30.8914 19.7584 30.9013C20.3594 30.9904 20.9662 31.035 21.5739 31.0349C24.8912 31.0333 28.073 29.7184 30.4237 27.3776C30.5195 27.2817 30.5734 27.1517 30.5734 27.0161C30.5734 26.8805 30.5195 26.7504 30.4237 26.6545L22.313 18.5439ZM23.9581 15.1058C24.0281 15.0345 24.1115 14.9777 24.2036 14.9388C24.2957 14.8999 24.3945 14.8797 24.4945 14.8792C24.5944 14.8787 24.6935 14.898 24.7859 14.9361C24.8783 14.9741 24.9623 15.0301 25.033 15.1008C25.1037 15.1714 25.1597 15.2554 25.1977 15.3479C25.2357 15.4403 25.2551 15.5393 25.2546 15.6393C25.2541 15.7392 25.2338 15.8381 25.1949 15.9302C25.156 16.0223 25.0993 16.1057 25.0279 16.1757C24.8838 16.3133 24.6922 16.3901 24.493 16.3901C24.2937 16.3901 24.1022 16.3133 23.9581 16.1757C23.8162 16.0338 23.7365 15.8414 23.7365 15.6408C23.7365 15.4401 23.8162 15.2477 23.9581 15.1058ZM14.4438 24.2625C15.0051 24.2607 15.5471 24.4671 15.965 24.8418C16.3829 25.2165 16.647 25.7329 16.7063 26.2911L17.4168 32.6929H11.4749L12.1789 26.2945C12.2008 26.1005 12.2477 25.9102 12.3184 25.7282C12.3241 25.7145 12.3299 25.7012 12.3347 25.6873C12.5053 25.2673 12.7969 24.9076 13.1724 24.6539C13.548 24.4002 13.9905 24.2639 14.4438 24.2625Z" fill="#F0F0F0" />
                      <path d="M13.1331 13.5327C13.2436 13.4539 13.3183 13.3346 13.3408 13.2008C13.3632 13.067 13.3316 12.9297 13.2529 12.8192C13.1742 12.7087 13.0548 12.634 12.921 12.6116C12.7872 12.5891 12.65 12.6207 12.5395 12.6994C12.4546 12.7597 10.4649 14.2098 10.964 17.3703C10.983 17.4904 11.0442 17.5999 11.1366 17.679C11.229 17.7581 11.3466 17.8017 11.4683 17.8019C11.4952 17.8019 11.5221 17.7998 11.5487 17.7954C11.6827 17.7743 11.8028 17.7008 11.8825 17.5912C11.9623 17.4815 11.9953 17.3447 11.9742 17.2107C11.5794 14.7075 13.0605 13.5858 13.1331 13.5327Z" fill="#F0F0F0" />
                      <path d="M30.0166 10.107C29.018 9.10841 27.7762 8.38747 26.4139 8.0153C26.2841 7.98282 26.1467 8.0025 26.0313 8.07013C25.9158 8.13776 25.8314 8.24794 25.7963 8.37705C25.7611 8.50616 25.778 8.64391 25.8432 8.76074C25.9085 8.87757 26.0169 8.96418 26.1452 9.00198C27.3428 9.32938 28.4337 9.96505 29.3089 10.8456C30.1842 11.7261 30.8133 12.8207 31.1335 14.0203C31.1625 14.1291 31.2266 14.2253 31.3159 14.294C31.4052 14.3627 31.5146 14.4 31.6272 14.4001C31.6719 14.4 31.7163 14.3941 31.7595 14.3827C31.8905 14.3477 32.0023 14.2621 32.0702 14.1447C32.1381 14.0273 32.1566 13.8878 32.1216 13.7567C31.7527 12.3764 31.0267 11.1175 30.0166 10.107Z" fill="#F0F0F0" />
                      <path d="M29.0162 14.0662C29.0397 14.1291 29.0753 14.1868 29.1211 14.236C29.1669 14.2851 29.2219 14.3248 29.283 14.3527C29.3441 14.3806 29.4101 14.3961 29.4772 14.3985C29.5443 14.4009 29.6113 14.39 29.6742 14.3666C29.7371 14.3431 29.7948 14.3074 29.844 14.2617C29.8931 14.2159 29.9328 14.1609 29.9607 14.0998C29.9886 14.0387 30.0041 13.9727 30.0065 13.9055C30.0089 13.8384 29.998 13.7715 29.9746 13.7086C29.6713 12.9002 29.1995 12.1656 28.5905 11.5536C27.9815 10.9417 27.2493 10.4663 26.4424 10.159C26.3155 10.111 26.1747 10.1155 26.0511 10.1713C25.9274 10.2271 25.831 10.3298 25.783 10.4567C25.7351 10.5836 25.7395 10.7243 25.7953 10.848C25.8511 10.9717 25.9538 11.0681 26.0807 11.116C26.7512 11.3715 27.3597 11.7666 27.8659 12.2753C28.372 12.7839 28.7641 13.3944 29.0162 14.0662Z" fill="#F0F0F0" />
                      <path d="M26.5273 12.4745C26.4714 12.4373 26.4086 12.4114 26.3426 12.3984C26.2767 12.3853 26.2088 12.3854 26.1428 12.3987C26.0769 12.4119 26.0142 12.438 25.9584 12.4754C25.9025 12.5128 25.8546 12.5609 25.8173 12.6169C25.78 12.6728 25.7542 12.7356 25.7411 12.8016C25.7281 12.8675 25.7282 12.9354 25.7414 13.0014C25.7547 13.0673 25.7807 13.13 25.8182 13.1858C25.8556 13.2417 25.9037 13.2896 25.9597 13.3269C26.294 13.5493 26.5804 13.8363 26.8021 14.1711C26.8799 14.2765 26.9952 14.3481 27.1242 14.371C27.2533 14.3939 27.3862 14.3664 27.4955 14.2942C27.6049 14.222 27.6823 14.1106 27.7119 13.9829C27.7415 13.8553 27.7209 13.7211 27.6545 13.6082C27.5056 13.3826 27.3342 13.1726 27.1431 12.9815C26.9549 12.7928 26.7487 12.6229 26.5273 12.4745Z" fill="#F0F0F0" />
                    </svg>

                  </button>
                </div>
                <div className="modalComponentTxt">List</div>
              </div>
              <div className="modalComponentItem">
                <div className="modalComponentBtnBox">
                  <button
                    className={
                      isSelectedModalComponent === "Add"
                        ? "activeModalComponentBtn modalComponentBtn"
                        : "modalComponentBtn"
                    }
                    onClick={() => {
                      setSelectedModalComponent("Add");
                    }}
                  >
                    <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.13308 5.53265C5.24358 5.45394 5.31828 5.33456 5.34075 5.20076C5.36323 5.06697 5.33163 4.92973 5.25292 4.81924C5.17421 4.70874 5.05482 4.63404 4.92103 4.61156C4.78724 4.58909 4.65 4.62068 4.5395 4.6994C4.45461 4.75974 2.46488 6.20976 2.96401 9.37028C2.98299 9.49044 3.04418 9.59991 3.1366 9.67902C3.22902 9.75813 3.34661 9.8017 3.46827 9.80191C3.49522 9.80194 3.52213 9.79978 3.54873 9.79543C3.68268 9.7743 3.80276 9.70083 3.88255 9.59118C3.96234 9.48153 3.99532 9.34468 3.97422 9.21072C3.57941 6.70753 5.06046 5.58584 5.13308 5.53265Z" fill="#F0F0F0" />
                      <path d="M22.0166 2.10697C21.018 1.10841 19.7762 0.387475 18.4139 0.0153032C18.2841 -0.0171843 18.1467 0.00249751 18.0313 0.0701264C17.9158 0.137755 17.8314 0.247944 17.7963 0.377053C17.7611 0.506162 17.778 0.643908 17.8432 0.760738C17.9085 0.877569 18.0169 0.964178 18.1452 1.00198C19.3428 1.32938 20.4337 1.96505 21.3089 2.84558C22.1842 3.72612 22.8133 4.82074 23.1335 6.02029C23.1625 6.12912 23.2266 6.22535 23.3159 6.29402C23.4052 6.3627 23.5146 6.39998 23.6272 6.4001C23.6719 6.39998 23.7163 6.39414 23.7595 6.38271C23.8905 6.3477 24.0023 6.26209 24.0702 6.1447C24.1381 6.02731 24.1566 5.88776 24.1216 5.75674C23.7527 4.37637 23.0267 3.11755 22.0166 2.10697Z" fill="#F0F0F0" />
                      <path d="M21.0162 6.0662C21.0397 6.12913 21.0753 6.18681 21.1211 6.23596C21.1669 6.28511 21.2219 6.32477 21.283 6.35266C21.3441 6.38055 21.4101 6.39614 21.4772 6.39852C21.5443 6.40091 21.6113 6.39005 21.6742 6.36657C21.7371 6.34308 21.7948 6.30743 21.844 6.26166C21.8931 6.21588 21.9328 6.16087 21.9607 6.09977C21.9886 6.03866 22.0041 5.97267 22.0065 5.90554C22.0089 5.83842 21.998 5.77148 21.9746 5.70855C21.6713 4.9002 21.1995 4.16563 20.5905 3.55364C19.9815 2.94165 19.2493 2.46625 18.4424 2.15902C18.3155 2.11105 18.1747 2.11546 18.0511 2.17128C17.9274 2.2271 17.831 2.32975 17.783 2.45666C17.7351 2.58357 17.7395 2.72434 17.7953 2.84799C17.8511 2.97165 17.9538 3.06807 18.0807 3.11604C18.7512 3.37147 19.3597 3.76663 19.8659 4.27527C20.372 4.78391 20.7641 5.3944 21.0162 6.0662Z" fill="#F0F0F0" />
                      <path d="M18.5273 4.47454C18.4714 4.43726 18.4086 4.41138 18.3426 4.39836C18.2767 4.38534 18.2088 4.38544 18.1428 4.39866C18.0769 4.41188 18.0142 4.43795 17.9584 4.4754C17.9025 4.51284 17.8546 4.56091 17.8173 4.61688C17.78 4.67285 17.7542 4.73561 17.7411 4.80158C17.7281 4.86755 17.7282 4.93543 17.7414 5.00137C17.7547 5.0673 17.7807 5.12998 17.8182 5.18583C17.8556 5.24168 17.9037 5.28962 17.9597 5.32689C18.294 5.54927 18.5804 5.83629 18.8021 6.17106C18.8799 6.27652 18.9952 6.34809 19.1242 6.37101C19.2533 6.39393 19.3862 6.36645 19.4955 6.29423C19.6049 6.22202 19.6823 6.11058 19.7119 5.98292C19.7415 5.85526 19.7209 5.72111 19.6545 5.60817C19.5056 5.38258 19.3342 5.17263 19.1431 4.98152C18.9549 4.79275 18.7487 4.62294 18.5273 4.47454Z" fill="#F0F0F0" />
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.655 9.20262L14.313 10.5439L19.3155 15.5464C18.7042 15.2986 18.0528 15.1291 17.3737 15.0504L13.2285 10.9049L5.12399 2.80248C3.43174 4.63472 2.38718 6.97145 2.15051 9.45435C1.91384 11.9372 2.49813 14.4292 3.81376 16.5482C4.12258 16.1431 4.52035 15.8145 4.97637 15.5876C5.43238 15.3607 5.93444 15.2417 6.44377 15.2397C7.25761 15.237 8.04351 15.5363 8.64952 16.0795C9.25553 16.6227 9.63859 17.3713 9.72465 18.1806L9.82425 19.0783C9.44005 19.8264 9.1779 20.6474 9.06409 21.5151L8.70626 18.2911C8.64702 17.7329 8.38291 17.2165 7.965 16.8418C7.54709 16.4671 7.00507 16.2607 6.44377 16.2625C5.99054 16.2639 5.54799 16.4002 5.17242 16.6539C4.79685 16.9076 4.50525 17.2673 4.33472 17.6873C4.33042 17.6999 4.32529 17.7119 4.32007 17.7241L4.31835 17.7282C4.24771 17.9102 4.20085 18.1005 4.17891 18.2945L3.47487 24.6929H9.32567C9.43349 25.0461 9.56667 25.3882 9.72308 25.7171H2.98766C2.46678 25.7176 1.96738 25.9248 1.59903 26.2931C1.23068 26.6614 1.02345 27.1607 1.02282 27.6816V29.4886C1.02282 29.6242 0.968941 29.7543 0.873032 29.8502C0.777124 29.9461 0.647045 30 0.511411 30C0.375776 30 0.245697 29.9461 0.149789 29.8502C0.0538805 29.7543 0 29.6242 0 29.4886V27.6816C0.000929067 26.9846 0.245211 26.3099 0.69066 25.7739C1.13611 25.2379 1.75476 24.8742 2.43977 24.7458L3.16256 18.1792C3.18683 17.9849 3.2279 17.793 3.2853 17.6058C1.62381 15.2056 0.860618 12.2971 1.12964 9.39036C1.39865 6.48367 2.68269 3.76455 4.75646 1.71011C4.85235 1.61434 4.98233 1.56055 5.11786 1.56055C5.25338 1.56055 5.38336 1.61434 5.47925 1.71011L13.5899 9.82075L14.9318 8.47949C14.7726 8.18767 14.6979 7.85722 14.7162 7.5253C14.7345 7.19337 14.8451 6.87313 15.0354 6.60058C15.2257 6.32803 15.4883 6.11398 15.7936 5.98249C16.0989 5.851 16.4349 5.80729 16.7637 5.85627C17.0925 5.90525 17.4011 6.04498 17.6548 6.25976C17.9086 6.47453 18.0974 6.75583 18.2 7.07202C18.3026 7.38821 18.315 7.72676 18.2358 8.0496C18.1565 8.37245 17.9888 8.66679 17.7514 8.89952C17.4826 9.1714 17.1324 9.34811 16.754 9.40281C16.3757 9.45752 15.9898 9.38723 15.655 9.20262ZM11.8678 28.3989V28.9772H1.74186C1.60623 28.9772 1.47615 29.0311 1.38024 29.127C1.28433 29.2229 1.23045 29.3529 1.23045 29.4886C1.23045 29.6242 1.28433 29.7543 1.38024 29.8502C1.47615 29.9461 1.60623 30 1.74186 30H12.3792C12.5148 30 12.6449 29.9461 12.7408 29.8502C12.8367 29.7543 12.8906 29.6242 12.8906 29.4886V29.076C12.5306 28.878 12.1887 28.6513 11.8678 28.3989ZM16.2036 6.93883C16.1115 6.97773 16.0281 7.03449 15.9581 7.10584C15.8162 7.24771 15.7365 7.44013 15.7365 7.64077C15.7365 7.84141 15.8162 8.03383 15.9581 8.17571C16.1022 8.3133 16.2937 8.39008 16.493 8.39008C16.6922 8.39008 16.8838 8.3133 17.0279 8.17571C17.0993 8.1057 17.156 8.02225 17.1949 7.93018C17.2338 7.83811 17.2541 7.73924 17.2546 7.63929C17.2551 7.53934 17.2357 7.44029 17.1977 7.34785C17.1597 7.25542 17.1037 7.17144 17.033 7.10076C16.9623 7.03008 16.8783 6.97411 16.7859 6.93608C16.6935 6.89805 16.5944 6.87871 16.4945 6.87918C16.3945 6.87965 16.2957 6.89993 16.2036 6.93883Z" fill="#F0F0F0" />
                      <path d="M17.8181 22.9999C17.8181 23.4821 17.6265 23.9446 17.2855 24.2855C16.9446 24.6265 16.4821 24.8181 15.9999 24.8181C15.5176 24.8181 15.0552 24.6265 14.7142 24.2855C14.3732 23.9446 14.1816 23.4821 14.1816 22.9999C14.1816 22.5176 14.3732 22.0552 14.7142 21.7142C15.0552 21.3732 15.5176 21.1816 15.9999 21.1816C16.4821 21.1816 16.9446 21.3732 17.2855 21.7142C17.6265 22.0552 17.8181 22.5176 17.8181 22.9999ZM17.1363 22.9999C17.1363 22.6985 17.0165 22.4094 16.8034 22.1963C16.5903 21.9832 16.3013 21.8635 15.9999 21.8635C15.6985 21.8635 15.4094 21.9832 15.1963 22.1963C14.9832 22.4094 14.8635 22.6985 14.8635 22.9999C14.8635 23.3013 14.9832 23.5903 15.1963 23.8034C15.4094 24.0165 15.6985 24.1363 15.9999 24.1363C16.3013 24.1363 16.5903 24.0165 16.8034 23.8034C17.0165 23.5903 17.1363 23.3013 17.1363 22.9999Z" fill="#D8D8D8" />
                      <path d="M16.0003 18C16.1213 18 16.2422 18.0041 16.3626 18.0127C16.7094 18.0377 16.974 18.2932 17.0499 18.6055L17.2099 19.2646C17.2186 19.3 17.2508 19.3423 17.3122 19.365C17.4245 19.4055 17.5349 19.4514 17.6431 19.5023C17.7022 19.53 17.7549 19.5223 17.7863 19.5032L18.3658 19.1505C18.6399 18.9832 19.0072 18.99 19.2704 19.2173C19.4531 19.3759 19.625 19.5473 19.7832 19.7305C20.0109 19.9932 20.0173 20.3605 19.85 20.6351L19.4972 21.2142C19.4781 21.2455 19.4709 21.2983 19.4981 21.3573C19.5491 21.4655 19.595 21.576 19.6359 21.6883C19.6577 21.7496 19.7004 21.7814 19.7359 21.7905L20.395 21.9505C20.7073 22.0265 20.9627 22.291 20.9873 22.6378C21.0045 22.8792 21.0045 23.121 20.9873 23.3624C20.9627 23.7092 20.7073 23.9738 20.395 24.0497L19.7359 24.2097C19.7004 24.2183 19.6582 24.2506 19.6354 24.312C19.595 24.4247 19.5491 24.5351 19.4981 24.6429C19.4704 24.702 19.4781 24.7547 19.4972 24.7861L19.85 25.3656C20.0173 25.6397 20.0104 26.007 19.7832 26.2702C19.6245 26.4529 19.4531 26.6247 19.27 26.7829C19.0072 27.0107 18.6399 27.017 18.3654 26.8497L17.7863 26.497C17.7549 26.4779 17.7022 26.4706 17.6436 26.4979C17.5353 26.5489 17.4247 26.5948 17.3122 26.6357C17.2508 26.6575 17.219 26.7002 17.2099 26.7357L17.0499 27.3948C16.974 27.707 16.7094 27.9625 16.3626 27.987C16.1213 28.0043 15.8794 28.0043 15.6381 27.987C15.2912 27.9625 15.0267 27.707 14.9508 27.3948L14.7908 26.7357C14.7821 26.7002 14.7499 26.6579 14.6885 26.6352C14.576 26.5948 14.4656 26.549 14.3576 26.4979C14.2985 26.4702 14.2458 26.4779 14.2144 26.497L13.6348 26.8497C13.3607 27.017 12.9935 27.0102 12.7303 26.7829C12.5475 26.6243 12.3757 26.4529 12.2175 26.2697C11.9898 26.007 11.9834 25.6397 12.1507 25.3652L12.5034 24.7861C12.5225 24.7547 12.5298 24.702 12.5025 24.6433C12.4516 24.535 12.4056 24.4245 12.3648 24.312C12.343 24.2506 12.3003 24.2188 12.2648 24.2097L11.6057 24.0497C11.2934 23.9738 11.038 23.7092 11.013 23.3624C10.9957 23.1212 10.9957 22.879 11.013 22.6378C11.038 22.291 11.2934 22.0265 11.6057 21.9505L12.2648 21.7905C12.3003 21.7819 12.3425 21.7496 12.3653 21.6883C12.4057 21.5755 12.4516 21.4651 12.5025 21.3573C12.5303 21.2983 12.5225 21.2455 12.5034 21.2142L12.1507 20.6346C11.9834 20.3605 11.9903 19.9932 12.2175 19.73C12.3762 19.5473 12.5475 19.3755 12.7307 19.2173C12.9935 18.9896 13.3607 18.9832 13.6353 19.1505L14.2144 19.5032C14.2458 19.5223 14.2985 19.5296 14.3576 19.5023C14.4658 19.4514 14.5762 19.4055 14.6885 19.3646C14.7499 19.3428 14.7817 19.3 14.7908 19.2646L14.9508 18.6055C15.0267 18.2932 15.2912 18.0377 15.6381 18.0127C15.7576 18.0045 15.8785 18 16.0003 18ZM15.6867 18.6932C15.6617 18.695 15.6253 18.7159 15.6135 18.7664L15.4531 19.4255C15.4191 19.5587 15.3526 19.6814 15.2597 19.7827C15.1667 19.884 15.0501 19.9607 14.9203 20.006C14.8277 20.0395 14.7367 20.0773 14.6476 20.1191C14.5237 20.1791 14.3868 20.2074 14.2492 20.2015C14.1117 20.1956 13.9778 20.1558 13.8594 20.0855L13.2803 19.7328C13.2357 19.7055 13.1957 19.7164 13.1766 19.7328C13.0185 19.87 12.8702 20.0183 12.733 20.1764C12.7166 20.1955 12.7057 20.236 12.733 20.2801L13.0857 20.8592C13.2285 21.0996 13.2412 21.3955 13.1194 21.6474C13.0775 21.7365 13.0398 21.8275 13.0062 21.9201C12.961 22.0501 12.8843 22.1668 12.7829 22.2598C12.6815 22.3529 12.5586 22.4194 12.4253 22.4533L11.7662 22.6128C11.7162 22.6251 11.6952 22.6615 11.6934 22.6865C11.6784 22.8953 11.6784 23.1049 11.6934 23.3138C11.6952 23.3388 11.7162 23.3751 11.7666 23.3869L12.4257 23.5474C12.5589 23.5814 12.6817 23.6478 12.7829 23.7408C12.8842 23.8337 12.9609 23.9503 13.0062 24.0801C13.0398 24.1729 13.0775 24.2638 13.1194 24.3529C13.2412 24.6042 13.2285 24.9002 13.0857 25.1406L12.733 25.7202C12.7057 25.7647 12.7166 25.8047 12.733 25.8238C12.8698 25.982 13.0185 26.1306 13.1766 26.2675C13.1957 26.2838 13.2362 26.2947 13.2803 26.2675L13.8594 25.9147C13.9777 25.8443 14.1116 25.8042 14.2492 25.7983C14.3868 25.7923 14.5236 25.8206 14.6476 25.8806C14.7367 25.9229 14.8276 25.9606 14.9203 25.9943C15.0503 26.0395 15.167 26.1162 15.2601 26.2176C15.3531 26.319 15.4196 26.4418 15.4535 26.5752L15.6131 27.2343C15.6253 27.2843 15.6617 27.3052 15.6867 27.307C15.8955 27.322 16.1052 27.322 16.314 27.307C16.339 27.3052 16.3753 27.2843 16.3872 27.2338L16.5476 26.5747C16.5816 26.4415 16.6481 26.3187 16.741 26.2173C16.834 26.116 16.9505 26.0392 17.0804 25.9938C17.173 25.9606 17.264 25.923 17.3531 25.8811C17.477 25.8211 17.6137 25.7928 17.7512 25.7987C17.8887 25.8046 18.0226 25.8444 18.1408 25.9147L18.7204 26.2675C18.7649 26.2947 18.805 26.2838 18.824 26.2675C18.9822 26.1306 19.1309 25.982 19.2677 25.8238C19.2841 25.8047 19.295 25.7643 19.2677 25.7202L18.915 25.1406C18.8447 25.0223 18.8048 24.8885 18.7989 24.751C18.7929 24.6136 18.8211 24.4768 18.8809 24.3529C18.9231 24.2638 18.9609 24.1729 18.9945 24.0801C19.0397 23.9502 19.1164 23.8334 19.2178 23.7404C19.3192 23.6473 19.4421 23.5809 19.5754 23.5469L20.2345 23.3874C20.2845 23.3751 20.3054 23.3388 20.3073 23.3138C20.3223 23.1049 20.3223 22.8953 20.3073 22.6865C20.3054 22.6615 20.2845 22.6251 20.2341 22.6133L19.575 22.4528C19.2904 22.3837 19.084 22.1687 18.994 21.9201C18.961 21.8274 18.9234 21.7364 18.8813 21.6474C18.8214 21.5234 18.7931 21.3866 18.7989 21.249C18.8048 21.1115 18.8447 20.9775 18.915 20.8592L19.2677 20.2801C19.295 20.2355 19.2841 20.1955 19.2677 20.1764C19.1304 20.0183 18.9822 19.87 18.824 19.7328C18.805 19.7164 18.7645 19.7055 18.7204 19.7328L18.1408 20.0855C18.0226 20.1558 17.8887 20.1957 17.7512 20.2015C17.6137 20.2074 17.477 20.1791 17.3531 20.1191C17.264 20.0771 17.173 20.0394 17.0804 20.006C16.9505 19.9606 16.8338 19.8838 16.7408 19.7825C16.6478 19.6811 16.5812 19.5583 16.5472 19.425L16.3876 18.7659C16.3753 18.7159 16.339 18.695 16.314 18.6932C16.1052 18.6782 15.8955 18.6782 15.6867 18.6932Z" fill="#D8D8D8" />
                    </svg>

                  </button>
                </div>
                <div className="modalComponentTxt">Add</div>
              </div>
              {/* <div className="modalComponentItem" style={{visibility:"hidden"}}>
                <div className="modalComponentBtnBox">
                  <button
                    className={
                      isSelectedModalComponent === "Map"
                        ? "activeModalComponentBtn modalComponentBtn"
                        : "modalComponentBtn"
                    }
                    onClick={() => {
                      setSelectedModalComponent("Map");
                      setBoundingBox(true);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M13.5625 2.30731C13.561 1.82108 13.3704 1.35452 13.0309 1.00642C12.6914 0.658329 12.2298 0.456037 11.7438 0.442389C11.2577 0.42874 10.7855 0.604808 10.427 0.933305C10.0685 1.2618 9.85196 1.71693 9.82321 2.20231L3.99326 3.36811C3.85696 3.0848 3.65143 2.84042 3.39568 2.65756C3.13994 2.47471 2.84222 2.35927 2.53006 2.32191C2.21789 2.28456 1.90134 2.3265 1.60968 2.44386C1.31801 2.56122 1.06063 2.75021 0.861327 2.99336C0.662026 3.23651 0.527234 3.52598 0.469408 3.83501C0.411583 4.14403 0.432591 4.46265 0.53049 4.76142C0.628388 5.06018 0.80002 5.32944 1.02952 5.54432C1.25902 5.7592 1.53898 5.91276 1.84354 5.99081V9.874C1.52384 9.95606 1.23154 10.1213 0.996315 10.3528C0.761089 10.5843 0.591309 10.874 0.504206 11.1924C0.417103 11.5107 0.415779 11.8465 0.500367 12.1655C0.584955 12.4845 0.752445 12.7755 0.985837 13.0089C1.21923 13.2423 1.51021 13.4098 1.82925 13.4944C2.1483 13.579 2.48404 13.5777 2.8024 13.4905C3.12077 13.4034 3.41042 13.2337 3.64196 12.9984C3.87351 12.7632 4.0387 12.4709 4.12077 12.1512H8.00396C8.08189 12.456 8.23539 12.7362 8.45029 12.9659C8.66519 13.1956 8.93454 13.3674 9.23343 13.4654C9.53232 13.5634 9.85111 13.5845 10.1603 13.5267C10.4695 13.4689 10.7591 13.3341 11.0024 13.1346C11.2457 12.9352 11.4348 12.6777 11.5521 12.3859C11.6695 12.094 11.7114 11.7773 11.674 11.465C11.6365 11.1527 11.5209 10.8549 11.3379 10.599C11.1548 10.3432 10.9102 10.1377 10.6267 10.0015L11.7925 4.17156C12.2697 4.14547 12.7189 3.93785 13.048 3.59123C13.3771 3.24462 13.5612 2.78527 13.5625 2.30731ZM11.6875 1.36979C11.8729 1.36979 12.0541 1.42478 12.2083 1.52779C12.3625 1.63081 12.4827 1.77723 12.5536 1.94854C12.6246 2.11984 12.6431 2.30835 12.607 2.49021C12.5708 2.67207 12.4815 2.83912 12.3504 2.97023C12.2193 3.10135 12.0522 3.19063 11.8704 3.22681C11.6885 3.26298 11.5 3.24442 11.3287 3.17346C11.1574 3.1025 11.011 2.98234 10.9079 2.82816C10.8049 2.67399 10.7499 2.49273 10.7499 2.30731C10.7502 2.05874 10.849 1.82042 11.0248 1.64466C11.2006 1.46889 11.4389 1.37004 11.6875 1.36979ZM1.37478 4.18234C1.37478 3.99692 1.42976 3.81566 1.53278 3.66148C1.63579 3.50731 1.78221 3.38715 1.95352 3.31619C2.12483 3.24523 2.31334 3.22666 2.4952 3.26284C2.67706 3.29901 2.84411 3.3883 2.97522 3.51942C3.10633 3.65053 3.19562 3.81758 3.2318 3.99944C3.26797 4.1813 3.24941 4.3698 3.17845 4.54111C3.10749 4.71242 2.98733 4.85884 2.83315 4.96185C2.67898 5.06487 2.49772 5.11985 2.31229 5.11985C2.06373 5.11961 1.82541 5.02075 1.64964 4.84499C1.47388 4.66922 1.37503 4.43091 1.37478 4.18234ZM2.31229 12.62C2.12687 12.62 1.94561 12.565 1.79144 12.462C1.63726 12.359 1.5171 12.2125 1.44614 12.0412C1.37518 11.8699 1.35662 11.6814 1.39279 11.4996C1.42897 11.3177 1.51826 11.1507 1.64937 11.0195C1.78048 10.8884 1.94753 10.7991 2.12939 10.763C2.31125 10.7268 2.49976 10.7454 2.67107 10.8163C2.84238 10.8873 2.9888 11.0074 3.09181 11.1616C3.19483 11.3158 3.24981 11.497 3.24981 11.6825C3.24956 11.931 3.15071 12.1693 2.97495 12.3451C2.79918 12.5209 2.56086 12.6197 2.31229 12.62ZM8.00396 11.2137H4.12077C4.0368 10.8914 3.86838 10.5974 3.63289 10.3619C3.39739 10.1264 3.10334 9.95796 2.78105 9.874V5.99081C3.16405 5.89118 3.50554 5.67256 3.75633 5.36643C4.00712 5.06029 4.15425 4.68245 4.17655 4.28734L10.0065 3.12154C10.1902 3.49946 10.4954 3.80482 10.8732 3.98874L9.70743 9.81821C9.31231 9.84051 8.93448 9.98765 8.62834 10.2384C8.32221 10.4892 8.10358 10.8307 8.00396 11.2137ZM9.81243 12.62C9.62701 12.62 9.44575 12.565 9.29157 12.462C9.1374 12.359 9.01724 12.2125 8.94628 12.0412C8.87532 11.8699 8.85675 11.6814 8.89293 11.4996C8.9291 11.3177 9.01839 11.1507 9.14951 11.0195C9.28062 10.8884 9.44767 10.7991 9.62953 10.763C9.81139 10.7268 9.9999 10.7454 10.1712 10.8163C10.3425 10.8873 10.4889 11.0074 10.5919 11.1616C10.695 11.3158 10.7499 11.497 10.7499 11.6825C10.7497 11.931 10.6508 12.1693 10.4751 12.3451C10.2993 12.5209 10.061 12.6197 9.81243 12.62Z"
                        fill={"#F0F0F0"}
                      />
                    </svg>
                  </button>
                </div>
                <div className="modalComponentTxt">Map</div>
              </div> */}


            </div>}

            <div className="modalScrollableSection modalGroundStationDiv">
              {isSelectedModalComponent === "List" && (
                <>
                  <div className="modalSubHeader modalGreenSubHeader">
                    Select Ground station
                  </div>
                  {dropdownOptions.length > 0 && (
                    <div className="dropdownSpacer">
                      <ModalDropdown
                        options={dropdownOptions}
                        isMulti={"true"}
                        handleSelectedOption={handleSelectedOption}
                        previousOption={previousOption}
                      />
                    </div>
                  )}
                </>
              )}
              {isSelectedModalComponent === "Add" && (
                <>
                  <div className={isEdit ? "modalSubHeader modalGreenSubHeader topMarginClass" : "modalSubHeader modalGreenSubHeader"}>
                    Ground station {isEdit ? "- " + props?.componentData?.title : ""}
                  </div>
                  <div className="referenceOrbitDiv">
                    <div className="modalAnalysisDiv">
                      <div className="modalAnalysisText">Latitude (km)</div>
                      <input
                        autoComplete="off"
                        value={latitude}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13 || e.keyCode === 69) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          setLatitude(event.target.value);
                          // parameterProps.setGroundStationParameters({
                          //   Latitude: event.target.value,
                          //   Longitude: parameterProps.Longitude,
                          //   Height: parameterProps.Height,
                          // });
                        }}
                        className="modalAnalysisInput"
                        type="number"
                        placeholder="in Km"
                      />
                    </div>

                    <div className="modalAnalysisDiv">
                      <div className="modalAnalysisText">Longitude (km)</div>
                      <input
                        value={longitude}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13 || e.keyCode === 69) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          setLongitude(event.target.value);
                        }}
                        className="modalAnalysisInput"
                        type="number"
                        placeholder="in km"
                      />
                    </div>

                    <div className="modalAnalysisDiv">
                      <div className="modalAnalysisText">Height (km)</div>
                      <input
                        value={height}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13 || e.keyCode === 69) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          setHeight(event.target.value);
                        }}
                        className="modalAnalysisInput"
                        type="number"
                        placeholder="in Km"
                      />
                    </div>

                    <div className="modalAnalysisDiv">
                      <div className="modalAnalysisText">Minimum Bandwidth</div>
                      <input
                        value={minBandwidth}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13 || e.keyCode === 69) {
                            e.preventDefault();
                          }
                        }}
                        onChange={(event) => {
                          setMinBandwidth(event.target.value);
                        }}
                        className="modalAnalysisInput"
                        type="number"
                        placeholder="in bps"
                      />
                    </div>

                    <div className="modalAnalysisDiv">
                      <div className="modalAnalysisText">Frequency Band</div>
                    </div>
                    <div className="modalCheckboxDiv">
                      <div className="modalCheckboxSubDiv">
                        <button
                          onClick={() => {
                            setFrequencyType(frequencyType);
                            setFrequencyBandItems({
                              ...frequencyBandItems,
                              XBand: !frequencyBandItems.XBand,
                              SBand: frequencyBandItems.SBand,
                              UHF: frequencyBandItems.UHF,
                            });
                          }}
                          className="modalCheckBoxBtn disabledBtn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="15"
                              height="15"
                              rx="3.5"
                              stroke="#F0F0F0"
                            />
                            {frequencyBandItems.XBand && (
                              <path
                                d="M4 8L6.5 10.5L13 4"
                                stroke="#F0F0F0"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            )}
                          </svg>
                        </button>
                        <div className="modalCheckboxText disabledBtn">
                          X-Band
                        </div>
                      </div>

                      <div className="modalCheckboxSubDiv">
                        <button
                          onClick={() => {
                            setFrequencyBandItems({
                              ...frequencyBandItems,
                              XBand: frequencyBandItems.XBand,
                              SBand: !frequencyBandItems.SBand,
                              UHF: frequencyBandItems.UHF,
                            });
                          }}
                          className="modalCheckBoxBtn disabledBtn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="15"
                              height="15"
                              rx="3.5"
                              stroke="#F0F0F0"
                            />
                            {frequencyBandItems.SBand && (
                              <path
                                d="M4 8L6.5 10.5L13 4"
                                stroke="#F0F0F0"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            )}
                          </svg>
                        </button>
                        <div className="modalCheckboxText disabledBtn">
                          S-Band
                        </div>
                      </div>

                      <div className="modalCheckboxSubDiv">
                        <button
                          onClick={() => {
                            setFrequencyBandItems({
                              ...frequencyBandItems,
                              XBand: frequencyBandItems.XBand,
                              SBand: frequencyBandItems.SBand,
                              UHF: !frequencyBandItems.UHF,
                            });
                          }}
                          className="modalCheckBoxBtn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="15"
                              height="15"
                              rx="3.5"
                              stroke="#F0F0F0"
                            />
                            {frequencyBandItems.UHF && (
                              <path
                                d="M4 8L6.5 10.5L13 4"
                                stroke="#F0F0F0"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            )}
                          </svg>
                        </button>
                        <div className="modalCheckboxText">UHF</div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="modalFooter">
              <button
                className="modalFooterclose"
                onClick={() => {
                  setisModalVisible(false);
                  props.setBottombarProps({ bottombarComponent: "", componentId: "", componentData: "" });
                }}
              >
                Close
              </button>
              <button
                className="modalFooterapply"
                onClick={() => {
                  postGroundStation();
                  // addToSidebarComponent();
                  // setisModalVisible(false);
                }}
              >
                {!loading ? "Add" : "Adding..."}&nbsp;
                {loading &&
                  <CircularProgress size={10} className="text-white" />
                }
              </button>
            </div>
          </div>
          {isBoundingBox && (
            <BoundingBox
              props={props}
              parameterProps={parameterProps}
              setBoundingBoxVisibility={setBoundingBox}
              setboundingBoxParameters={setboundingBoxParameters}
            />
          )}
        </>
      )}
    </>
  );
};

export default GroundStationModal;
